<!-- 首页右边框-主内容 -->
<template>
	<div>
		<el-row :gutter="20">
			<el-col :span="16" style="overflow-y:scroll;" :style="{height:maxHeight+'px'}" class="gdt">
				<div class="d-flex">
					<div style="background: #fff;border-radius: 6px;width: 23.5%;height: 100px;margin-right: 2%;justify-content: center;" class="d-flex align-items-center">
						<div style="width: 66%;margin-left: 6%;">
							<div style="font-size: 13px;margin-bottom: 4px;">今日成交额</div>
							<div style="font-size: 16px;font-weight: 800;">￥1263456元</div>
						</div>
						<div style="width: 28%;">
							<img src="@/image/index1.png" style="width: 36px;height: 36px;">
						</div>
					</div>
					<div style="background: #fff;border-radius: 6px;width: 23.5%;height: 100px;margin-right: 2%;justify-content: center;" class="d-flex align-items-center">
						<div style="width: 66%;margin-left: 6%;">
							<div style="font-size: 13px;margin-bottom: 4px;">今日吞吐量</div>
							<div style="font-size: 16px;font-weight: 800;">{{jrttl.toFixed(2)}}吨</div>
						</div>
						<div style="width: 28%;">
							<img src="@/image/index4.png" style="width: 36px;height: 36px;">
						</div>
					</div>
					<div style="background: #fff;border-radius: 6px;width: 23.5%;height: 100px;margin-right: 2%;justify-content: center;" class="d-flex align-items-center">
						<div style="width: 66%;margin-left: 6%;">
							<div style="font-size: 13px;margin-bottom: 4px;">月吞吐量</div>
							<div style="font-size: 16px;font-weight: 800;">{{yuettl.toFixed(2)}}吨</div>
						</div>
						<div style="width: 28%;">
							<img src="@/image/index3.png" style="width: 36px;height: 36px;">
						</div>
					</div>
					<div style="background: #fff;border-radius: 6px;width: 23.5%;height: 100px;justify-content: center;" class="d-flex align-items-center">
						<div style="width: 66%;margin-left: 6%;">
							<div style="font-size: 13px;margin-bottom: 4px;">仓库储能百分比</div>
							<div style="font-size: 16px;font-weight: 800;">{{ccbfb}}%</div>
						</div>
						<div style="width: 28%;">
							<img src="@/image/index2.png" style="width: 36px;height: 36px;">
						</div>
					</div>
				</div>
				<div class="d-flex" style="margin-top: 10px;">
					<div style="background: #fff;border-radius: 6px;width: 49%;height: 380px;margin-right: 2%;">
						<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
							<div style="font-size: 16px;margin-left: 10px;font-weight: 800;">今日单据数据</div>
						</div>
						<div ref="myCharpath1" style="width: 100%; height: 330px;"></div>
					</div>
					<div style="background: #fff;border-radius: 6px;width: 49%;height: 380px;">
						<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
							<div style="font-size: 16px;margin-left: 10px;font-weight: 800;">各仓库存储占比</div>
						</div>
						<div ref="myCharpath2" style="width: 100%; height: 300px;"></div>
					</div>
				</div>
				<div class="d-flex" style="margin-top: 10px;">
					<div style="background: #fff;border-radius: 6px;width: 100%;height: 440px;">
						<div class="d-flex align-items-center" style="width: 100%;height: 60px;">
							<div style="font-size: 16px;margin-left: 10px;font-weight: 800;">仓库15日流水</div>
						</div>
						<div ref="myCharpath3" style="width: 100%; height: 360px;"></div>
					</div>
				</div>
				
				<el-card class="box-card" style="height: 610px;margin-top: 10px;" shadow="never">
					<div slot="header" class="clearfix d-flex a-center">
						<span style="font-weight: 800;">收发中心</span>
						<span>
							<div class="ml-1 d-flex a-center j-center" style="width: 20px;height: 20px;background: #ea9d02;border-radius: 20px;">
								<div style="font-size: 10px;color: #fff;">{{sfzxa.length + sfzxb.length}}</div>
							</div>
						</span>
					</div>
					<div style="width: 100%;height: 250px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 10%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">入仓单</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">订单项目</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">存储方式</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">仓库</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">货物类型</div>
							<div style="width: 13%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 17%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itema, indexa) in sfzxa" :key="indexa" v-if="indexa < 6">
							<div style="width: 10%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itema.bh}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.hwxm}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.ccfsdata == null ? '' : itema.ccfsdata.name}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.ckdata == null ? '' : itema.ckdata.name}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.hwlxdata == null ? '' : itema.hwlxdata.name}}</div>
							<div style="width: 13%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.ddrq}}</div>
							<div style="width: 17%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;" @click="lqrcd(itema)">领取</div>
						</div>
					</div>
					<div style="width: 100%;height: 250px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 10%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">出仓单</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">订单项目</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">仓库</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓件数</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓重量</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓面积</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓体积</div>
							<div style="width: 13%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 17%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itemb, indexb) in sfzxb" :key="indexb" v-if="indexb < 6">
							<div style="width: 10%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itemb.bh}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.hwxm}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ckdata == null ? '' : itemb.ckdata.name}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ccjs}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.cczl}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ccmj}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.cctj}}</div>
							<div style="width: 13%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ddrq}}</div>
							<div style="width: 17%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;" @click="lqccd(itemb)">领取</div>
						</div>
					</div>
				</el-card>
				<el-card class="box-card" style="height: 610px;margin-top: 10px;" shadow="never">
					<div slot="header" class="clearfix d-flex a-center">
						<span style="font-weight: 800;">仓储中心</span>
						<span>
							<div class="ml-1 d-flex a-center j-center" style="width: 20px;height: 20px;background: #ea9d02;border-radius: 20px;">
								<div style="font-size: 10px;color: #fff;">{{cczx.length}}</div>
							</div>
						</span>
					</div>
					<div style="width: 100%;height: 250px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 10%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">入仓任务</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">订单项目</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">计费重量</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">仓库</div>
							<div style="width: 15%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">货物类型</div>
							<div style="width: 13%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 17%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itema, indexa) in cczx" :key="indexa" v-if="indexa < 6">
							<div style="width: 10%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itema.bh}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.hwxm}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.jfsl}}<span style="margin-left: 4px;color: #007bff;">{{ itema.jfdwdata == null ? '' : itema.jfdwdata.name }}</span></div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.ckdata == null ? '' : itema.ckdata.name}}</div>
							<div style="width: 15%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.hwlxdata == null ? '' : itema.hwlxdata.name}}</div>
							<div style="width: 13%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.ddrq}}</div>
							<div style="width: 17%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;" @click="lqrcrw(itema)">领取</div>
						</div>
					</div>
					<div style="width: 100%;height: 250px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 10%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">出仓任务</div>
							<div style="width: 12%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">订单项目</div>
							<div style="width: 12%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">仓库</div>
							<div style="width: 12%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓件数</div>
							<div style="width: 12%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓重量</div>
							<div style="width: 12%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">出仓体积</div>
							<div style="width: 13%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 17%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itemb, indexb) in cczxb" :key="indexb" v-if="indexb < 6">
							<div style="width: 10%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itemb.bh}}</div>
							<div style="width: 12%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.hwxm}}</div>
							<div style="width: 12%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ckdata == null ? '' : itemb.ckdata.name}}</div>
							<div style="width: 12%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ccjs}}</div>
							<div style="width: 12%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.cczl}}</div>
							<div style="width: 12%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.cctj}}</div>
							<div style="width: 13%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.ddrq}}</div>
							<div style="width: 17%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;" @click="lqccrw(itemb)">领取</div>
						</div>
					</div>
				</el-card>
				<!-- <el-card class="box-card" style="height: 610px;margin-top: 10px;" shadow="never" :style="{  display: bm == 1 || bm == 8 ? '': 'none' }">
					<div slot="header" class="clearfix"><span style="font-weight: 800;">收入支出记账</span></div>
					<div style="width: 100%;height: 160px;">
						<div class="d-flex">
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">{{bm}}</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">当月收入/元</div>
								<div style="background: #ffbd14;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">4846.15</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">今日收入/元</div>
								<div style="background: #ff822e;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">846.15</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待审核收入/元</div>
								<div style="background: #ff2c1d;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">26.15</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待结算收入/元</div>
								<div style="background: #61ab11;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
						</div>
						<div class="d-flex mt-3">
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">876.85</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">当月支出/元</div>
								<div style="background: #00aaff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">94846.15</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">今日支出/元</div>
								<div style="background: #aa55ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">88.15</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待审核支出/元</div>
								<div style="background: #0055ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">286.15</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待结算支出/元</div>
								<div style="background: #0000ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
						</div>
					</div>
					<div class="txtx">最近7天现金流统计</div>
					<div ref="myCharta" style="width: 773px; height: 330px;"></div>
				</el-card> -->
				

				<!-- <el-card class="box-card" style="height: 610px;margin-top: 10px;" shadow="never" :style="{  display: bm == 1 || bm == 6 ? '': 'none' }">
					<div slot="header" class="clearfix"><span style="font-weight: 800;">采购管理</span></div>
					<div style="width: 100%;height: 160px;">
						<div class="d-flex">
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">43184</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">全部订单数</div>
								<div style="background: #ffbd14;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">246</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">本月订单数</div>
								<div style="background: #ff822e;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">84</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">今日订单数</div>
								<div style="background: #ff2c1d;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
						</div>
						<div class="d-flex mt-3">
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">82</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待审核订单</div>
								<div style="background: #00aaff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">48</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待入库订单</div>
								<div style="background: #aa55ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">18</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">待付款订单</div>
								<div style="background: #0055ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
						</div>
					</div>
					<div class="txtx">最近7天采购入库单统计</div>
					<div ref="myChartc" style="width: 773px; height: 330px;"></div>
				</el-card>
				<el-card class="box-card" style="height: 610px;margin-top: 10px;" shadow="never" :style="{  display: bm == 1 || bm == 7 ? '': 'none' }">
					<div slot="header" class="clearfix"><span style="font-weight: 800;">仓库管理</span></div>
					<div style="width: 100%;height: 160px;">
						<div class="d-flex">
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">43184</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">本月出库量</div>
								<div style="background: #ffbd14;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">246</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">本月入库量</div>
								<div style="background: #ff822e;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">84</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">今日出库量</div>
								<div style="background: #ff2c1d;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 25%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">84</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">今日入库量</div>
								<div style="background: #59aa0c;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
						</div>
						<div class="d-flex mt-3">
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">13482</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">库存总量</div>
								<div style="background: #00aaff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">48</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">出库总量</div>
								<div style="background: #aa55ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
							<div style="width: 33%;" class="d-flex j-j j-center a-center">
								<div style="font-weight: 800;color: #535353;">112348</div>
								<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">入库总量</div>
								<div style="background: #0055ff;height: 5px;width: 80%;border-radius: 2px;"></div>
							</div>
						</div>
					</div>
					<div class="txtx">最近7天仓库流量统计</div>
					<div ref="myChartd" style="width: 773px; height: 330px;"></div>
				</el-card>
				<el-card class="box-card" style="height: 410px;margin-top: 10px;" shadow="never" :style="{  display: bm == 1 || bm == 9 ? '': 'none' }">
					<div slot="header" class="clearfix"><span style="font-weight: 800;">生产管理</span></div>
					<div style="width: 100%;height: 200px;" class="d-flex">
						<div style="width: 50%;">
							<div class="d-flex">
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">43</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">规划中</div>
									<div style="background: #55aa00;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">20</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">工作安排</div>
									<div style="background: #ffaa00;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
							</div>
							<div class="d-flex mt-3">
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">184</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">生产中</div>
									<div style="background: #ffaa7f;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">9654</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">生产完成</div>
									<div style="background: #00ff7f;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
							</div>
							<div class="d-flex mt-3">
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">43184</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">订单总数</div>
									<div style="background: #ff0000;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">284</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">本月报工</div>
									<div style="background: #ff557f;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
							</div>
							<div class="d-flex mt-3">
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">31</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">昨日报工</div>
									<div style="background: #5555ff;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
								<div style="width: 50%;" class="d-flex j-j j-center a-center">
									<div style="font-weight: 800;color: #535353;">84</div>
									<div style="color: #a1a1a1;font-size: 12px;margin-top: 4px;margin-bottom: 6px;">今日报工</div>
									<div style="background: #ffaaff;height: 5px;width: 80%;border-radius: 2px;"></div>
								</div>
							</div>
						</div>
						<div style="width: 50%;">
							<div ref="myCharte" style="width: 503px; height: 330px;"></div>
						</div>
					</div>
				</el-card> -->
			</el-col>
			<el-col :span="8" style="overflow-y:scroll;" :style="{height:maxHeight+'px'}" class="gdt">
				<el-card class="box-card" style="height: 290px;" shadow="never">
					<div slot="header" class="clearfix"><span style="font-weight: 800;">常用功能</span></div>
					<div style="width: 100%;height: 180px;display: flex;flex-flow: row wrap;">
						<div style="display: flex;align-items: center;justify-content: center;flex-flow: column;width: 25%;padding-top: 12px;padding-bottom: 12px;" v-for="(item,index) in cyon" :key="index" @click="navigate(item.dz)">
							<img :src="item.url" style="width: 30px;height: 30px;margin-bottom: 5px;">
							<div style="font-size: 12px;color: #747474;">{{item.name}}</div>
						</div>
					</div>
				</el-card>
				<el-card class="box-card" style="height: 230px;margin-top: 10px;" shadow="never">
					<div slot="header" class="clearfix d-flex">
						<div style="width: 80%;font-weight: 800;">管理员信息</div>
						<div style="width: 80px;height: 30px;background: #40a6ff;color: #fff;font-size: 12px;display: flex;justify-content: center;align-items: center;border-radius: 6px;" @click="gos" v-if="user.role_id == 2">修改资料</div>
					</div>
					<div style="width: 100%;height: 200px;display: flex;">
						<div style="width: 45%;">
							<div style="display: flex;align-items: center;height: 30%;">
								<div style="font-size: 14px;color: #747474;">管理员头像：</div>
								<div><img :src="user.avatar" style="width: 30px;height: 30px;"></div>
							</div>
							<div style="display: flex;align-items: center;height: 30%;">
								<div style="font-size: 14px;color: #747474;">管理员姓名：</div>
								<div style="font-size: 14px;color: #747474;">{{user.name}}</div>
							</div>
						</div>
						<div style="width: 55%;">
							<div style="display: flex;align-items: center;height: 30%;">
								<div style="font-size: 14px;color: #747474;">管理员部门：</div>
								<div style="font-size: 14px;color: #fff;background: #6eb120;display: flex;justify-content: center;align-items: center;width: 70px;border-radius: 6px;height: 22px;">{{user.role.name}}</div>
							</div>
							<div style="display: flex;align-items: center;height: 30%;">
								<div style="font-size: 14px;color: #747474;">管理员编号：</div>
								<div style="font-size: 14px;color: #fff;background: #6eb120;display: flex;justify-content: center;align-items: center;width: 70px;border-radius: 6px;height: 22px;">GL100{{user.id}}</div>
							</div>
						</div>
					</div>
				</el-card>
				<el-card class="box-card" style="height: 340px;margin-top: 10px;" shadow="never">
					<div slot="header" class="clearfix d-flex a-center">
						<span style="font-weight: 800;">待办通知</span>
						<span>
							<div class="ml-1 d-flex a-center j-center" style="width: 20px;height: 20px;background: #ea9d02;border-radius: 20px;">
								<div style="font-size: 10px;color: #fff;">{{xxtz.length}}</div>
							</div>
						</span>
					</div>
					<div style="width: 100%;height: 200px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 53%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">公告标题</div>
							<div style="width: 30%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 17%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itema, indexa) in xxtz" :key="indexa" v-if='indexa<6'>
							<div style="width: 53%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itema.desc}}</div>
							<div style="width: 30%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itema.create_time.slice(0, 10)}}</div>
							<div style="width: 17%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;" @click="gotos(itema)">查看</div>
						</div>
					</div>
				</el-card>
				<el-card class="box-card" style="height: 340px;margin-top: 10px;" shadow="never">
					<div slot="header" class="clearfix d-flex a-center">
						<span style="font-weight: 800;">处理中通知</span>
						<span>
							<div class="ml-1 d-flex a-center j-center" style="width: 20px;height: 20px;background: #ea9d02;border-radius: 20px;">
								<div style="font-size: 10px;color: #fff;">{{xxtzclz.length}}</div>
							</div>
						</span>
					</div>
					<div style="width: 100%;height: 200px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 53%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">公告标题</div>
							<div style="width: 30%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 17%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itemb, indexb) in xxtzclz" :key="indexb" v-if='indexb<6'>
							<div style="width: 53%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itemb.desc}}</div>
							<div style="width: 30%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemb.create_time.slice(0, 10)}}</div>
							<div style="width: 17%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;" @click="gotos(itemb)">查看</div>
						</div>
					</div>
				</el-card>
			
				<!-- <el-card class="box-card" style="height: 340px;margin-top: 10px;" shadow="never">
					<div slot="header" class="clearfix"><span style="font-weight: 800;">最新公告</span></div>
					<div style="width: 100%;height: 200px;">
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);">
							<div style="width: 55%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;">公告标题</div>
							<div style="width: 25%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">发布日期</div>
							<div style="width: 20%;display: flex;align-items: center;font-weight: 800;height: 30px;font-size: 14px;justify-content: center;">操作</div>
						</div>
						<div style="display: flex;border-bottom: 1px solid rgb(0, 0, 0,0.1);" v-for="(itemc,indexc) in gglist" :key="indexc">
							<div style="width: 55%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;">{{itemc.title}}</div>
							<div style="width: 25%;display: flex;align-items: center;color:#747474;height: 34px;font-size: 12px;justify-content: center;">{{itemc.create_time.slice(0, 10)}}</div>
							<div style="width: 20%;display: flex;align-items: center;color:#fff;background: #40a6ff;height: 34px;font-size: 12px;justify-content: center;">查看</div>
						</div>
					</div>
				</el-card> -->
			</el-col>
			<strong></strong>
		</el-row>
		
	</div>
</template>

<script>
import { mapState } from 'vuex'; // 引入 全局 公共数据
import 'echarts/map/js/china.js';
import moment from 'moment';
import * as vueEcharts from "echarts";
let echarts = require('echarts');
export default {
	data() {
		return {
			maxHeight:10,
			day:'',
			myChart:null,
			cyon:[
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b661dcc7.png',name:'预收订单',dz:'xsgl_ddcl_xsdd'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b6699149.png',name:'入库订单',dz:'xsgl_ddcl_xsckd'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b661bfc6.png',name:'出库审批',dz:'cggl_ddcl_cgdd'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b661dcbd.png',name:'出库订单',dz:'cggl_ddcl_cgrk'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b6623ab1.png',name:'货物管理',dz:'zlgl_cpzl_cpgl'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b661dd01.png',name:'仓库明细',dz:'ckgl_ckxx_ckmx'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b662860f.png',name:'库存流水',dz:'ckgl_ckxx_kcls'},
				{url:'http://dgyh.oss-cn-hangzhou.aliyuncs.com/public/62ff0b668df51.png',name:'数据报表',dz:'scgl_scrw_scdd'}
			],
			xxtz:[],
			xxtzclz:[],
			bm:0,
			qx:true,
			gglist:[],
			sfzxa:[],
			sfzxb:[],
			cczx:[],
			cczxb:[],
			sy_ddlist:{},
			sy_cklist:[],
			daylist:[],
			sy_cklslist_rc:[],
			sy_cklslist_cc:[],
			moment,
			jrttl:0,
			yuettl:0,
			ccbfb:0
		};
	},
	// 动态计算过滤器，计算col-3百分比分配页面
	filters: {
		getCol(total) {
			return `col-${12 / total}`;
		}
	},
	computed: {
		// 引入store-modules的user模块里面的user(存储用户相关的数据)
		...mapState({
			user: state => state.user.user,
			navBar: state => state.menu.navBar
		})
	},
	// 生命周期
	created() {
		var now = new Date();
		var year = now.getFullYear(); // 年
		var month = now.getMonth() + 1; // 月
		var date = now.getDate(); // 日
		if (month < 10) month = '0' + month;
		if (date < 10) date = '0' + date;
		this.day = year + '-' + month + '-' + date;
	},
	// dom渲染完毕 mounted生命周期
	mounted() {
		// 画统计图
		this.bm = this.user.bmid
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 90; //300是页面中除了表格外其他组件的高度
		});
		this.sfzxadd()
		this.cczxdd()
		this.changeRecent()
		setTimeout(() => {
			this.drawLine();
		}, 6000);
		
		// this.axios
		// 	.get('/admin/notices', {
		// 		token: true
		// 	})
		// 	.then(res => {
		// 		this.gglist = res.data.data;
		// 	});
			
		const now = new Date();
		const year = now.getFullYear();
		const month = now.getMonth() + 1; // 月份从0开始，需要加1
		const day = now.getDate();
		const today = year +'-'+month+'-'+day
		this.axios.post('/admin/sy_ddlist', {today:today},{ token: true })
			.then(res => {
				this.sy_ddlist = res.data.data;
				console.log(res.data.data,'今日单据数据')
			});
		this.axios.post('/admin/sy_cklist', {},{ token: true })
			.then(res => {
				let data = res.data.data;
				this.sy_cklist = data.map(item=>{
					let num = 0
					for(let i of item.kclist){
						num += parseFloat(i.tj)
					}
					return {
						name: item.name,
						ck_num: (parseFloat(item.zdrl) - num).toFixed(2),
						zdrl:parseFloat(item.zdrl),
						num: num
					}
				})
				let ycc = 0
				let zkc = 0
				for(let cc of this.sy_cklist){
					ycc += cc.num
					zkc += cc.zdrl
				}
				this.ccbfb = (ycc / zkc * 100).toFixed(2)
			});
		this.axios.post('/admin/sy_cklslist', {},{ token: true })
			.then(res => {
				let list = res.data.data.yue_b;
				let list_yue = res.data.data.yue_a;
				console.log(this.daylist,111111)
				for(let c of this.daylist){
					let rc_num = 0
					let cc_num = 0
					let ls_day = c
					for(let e of list){
						if(e.create_time.slice(5,10) == c){
							rc_num += e.rc
							cc_num += e.cc
						}
						// 今天
						if(e.create_time.slice(5,10) == this.daylist[0]){
							let zds = e.js * parseFloat(e.mjzl) / 1000
							this.jrttl += zds
						}
					}
					this.sy_cklslist_rc.push(rc_num)
					this.sy_cklslist_cc.push(cc_num)
				}
				for(let all of list_yue){
					let tts = all.js * parseFloat(all.mjzl) / 1000
					this.yuettl += tts
				}
			});
	},
	// 画统计图方法
	methods: {
		lqrcd(e){
			let data = {
				id:e.id,
				sfy:this.user.id,
				sfjh:e.sfjh
			}
			this.axios.post('/admin/sfzxa/rcdd/lqrw', data, {token: true})
				.then(res => {
					this.$notify({
					    title: '成功',
					    message: '预收单领取成功',
						type: 'success'
					});
					this.sfzxadd()
				});
		},
		lqccd(e){
			let data = {
				id:e.id,
				sfy:this.user.id
			}
			this.axios.post('/admin/sfzxa/ccdd/lqrw', data, {token: true})
				.then(res => {
					this.$notify({
					    title: '成功',
					    message: '出仓单领取成功',
						type: 'success'
					});
					this.sfzxadd()
				});
		},
		lqrcrw(e){
			let data = {
				id:e.id,
				ckgly:this.user.id,
				sfjh:e.sfjh
			}
			this.axios.post('/admin/cczx/rcdd/lqrw', data, {token: true})
				.then(res => {
					this.$notify({
					    title: '成功',
					    message: '入仓任务领取成功',
						type: 'success'
					});
					this.cczxdd()
				});
		},
		lqccrw(e){
			let data = {
				id:e.id,
				ckgly:this.user.id
			}
			this.axios.post('/admin/cczx/ccdd/lqrw', data, {token: true})
				.then(res => {
					this.$notify({
					    title: '成功',
					    message: '出仓任务领取成功',
						type: 'success'
					});
					this.cczxdd()
				});
		},
		// 属性数据
		sfzxadd(){
			this.axios.get('/admin/sfzxa/rcdd', {
					token: true
				}).then(res => {
					this.sfzxa = res.data.data
				});
			this.axios.get('/admin/sfzxa/ccdd', {
					token: true
				}).then(res => {
					this.sfzxb = res.data.data
				});
			this.axios.get('/admin/xxtz/db/' + this.user.id, {
					token: true
				})
				.then(res => {
					this.xxtz = res.data.data;
				});
			this.axios.get('/admin/xxtz/dcl/' + this.user.id, {
					token: true
				})
				.then(res => {
					this.xxtzclz = res.data.data;
				});
		},
		cczxdd(){
			this.axios.get('/admin/cczx/rcdd', {
					token: true
				}).then(res => {
					this.cczx = res.data.data
					console.log(this.cczx,'111')
				});
			this.axios.get('/admin/cczx/ccdd', {
					token: true
				}).then(res => {
					this.cczxb = res.data.data
					console.log(this.cczxb,'22222')
				});
			this.axios.get('/admin/xxtz/db/' + this.user.id, {
					token: true
				})
				.then(res => {
					this.xxtz = res.data.data;
				});
			this.axios.get('/admin/xxtz/dcl/' + this.user.id, {
					token: true
				})
				.then(res => {
					this.xxtzclz = res.data.data;
				});
		},
		gotos(e) {
			let clz = {
				id:e.id,
				tzzt:1
			}
			let gos = ''
			if(e.ddlx == 3){
				gos = 'scgl_scrw_scdd'
			}else if(e.ddlx == 2){
				gos = 'cggl_ddcl_cgdd'
			}else if(e.ddlx == 1){
				gos = 'ccgl_ddcl_ccdd'
			}else if(e.ddlx == 4){
				gos = 'scgl_scrw_scll'
			}else if(e.ddlx == 5){
				gos = 'scgl_zjhrk_cprk'
			}else if(e.ddlx == 0){
				if(e.sfjh == 0){
					gos = 'rcgl_ddcl_rcdd'
				}else{
					gos = 'rcgl_ddcl_jhdd'
				}
			}else if(e.ddlx == 6){
				gos = 'xsgl_ddcl_xsckd'
			}
			this.axios.post('/admin/xxtz/update_status', clz, {token: true})
				.then(res => {
					this.$router.push({
						name: gos
					});
				});
			
		},
		navigate(name) {
			this.$router.push({
				name
			});
		},
		gos(){
			this.$router.push({
			name: 'set_manager'
			})
		},
		godo(e){
			this.$router.push({ path:e })
		},
		// 近15日
		changeRecent() {
			for(let i = 0;i<15;i++){
				this.daylist.push(moment(new Date().getTime() - i * 1000 * 24 * 60 * 60).format('MM-DD'))
				// this.cheshia.push(Math.floor(Math.random()*(10000-500))+500)
				// this.cheshib.push(Math.floor(Math.random()*(10000-500))+500)
				// this.cheshic.push(Math.floor(Math.random()*(10000-500))+500)
			}
			
		},
		drawLine() {	
			// 初始化echarts实例
			// let myCharta = echarts.init(this.$refs.myCharta);
			// let myChartc = echarts.init(this.$refs.myChartc);
			// let myChartd = echarts.init(this.$refs.myChartd);
			// let myCharte = echarts.init(this.$refs.myCharte);
			console.log(echarts.init(this.$refs.myCharpath3),999)
			let myCharpath1 = echarts.init(this.$refs.myCharpath1);
			let myCharpath2 = echarts.init(this.$refs.myCharpath2);
			let myCharpath3 = echarts.init(this.$refs.myCharpath3);
			
			var that = this;
			setTimeout(function() {
				// 配置参数
				// myCharta.setOption({
				// 	  tooltip: {
				// 	    trigger: 'axis'
				// 	  },
				// 	  grid: {
				// 	    left: '3%',
				// 	    right: '4%',
				// 	    bottom: '3%',
				// 	    containLabel: true
				// 	  },
				// 	  toolbox: {
				// 	    feature: {
				// 	      saveAsImage: {}
				// 	    }
				// 	  },
				// 	  xAxis: {
				// 	    type: 'category',
				// 	    boundaryGap: false,
				// 	    data: ['08-20', '08-19', '08-18', '08-17', '08-16', '08-15', '08-14']
				// 	  },
				// 	  yAxis: {
				// 	    type: 'value'
				// 	  },
				// 	  series: [
				// 	    {
				// 	      name: '今日收入',
				// 	      type: 'line',
				// 	      stack: 'Total',
				// 	      data: [9654, 5000, 4100, 15000, 5554, 8787, 3254]
				// 	    },
				// 	    {
				// 	      name: '今日支出',
				// 	      type: 'line',
				// 	      stack: 'Total',
				// 	      data: [9000, 4000, 2000, 5000, 2554, 8587, 254]
				// 	    },
				// 	    {
				// 	      name: '利润',
				// 	      type: 'line',
				// 	      stack: 'Total',
				// 	      data: [654, 1000, 2100, 10000, 3000, 200, 3000]
				// 	    },
				// 	  ]
				// }),
				
				// myChartc.setOption({
				// 	  tooltip: {
				// 	    trigger: 'axis'
				// 	  },
				// 	  grid: {
				// 	    left: '3%',
				// 	    right: '4%',
				// 	    bottom: '3%',
				// 	    containLabel: true
				// 	  },
				// 	  toolbox: {
				// 	    feature: {
				// 	      saveAsImage: {}
				// 	    }
				// 	  },
				// 	  xAxis: {
				// 	    type: 'category',
				// 	    boundaryGap: false,
				// 	    data: ['08-20', '08-19', '08-18', '08-17', '08-16', '08-15', '08-14']
				// 	  },
				// 	  yAxis: {
				// 	    type: 'value'
				// 	  },
				// 	  series: [
				// 	    {
				// 	      name: '订单数量',
				// 	      type: 'line',
				// 	      stack: 'Total',
				// 	      data: [824, 435, 647, 245, 167, 377, 614]
				// 	    },
				// 	  ]
				// }),
				// myChartd.setOption({
				// 	  tooltip: {
				// 	    trigger: 'axis'
				// 	  },
				// 	  grid: {
				// 	    left: '3%',
				// 	    right: '4%',
				// 	    bottom: '3%',
				// 	    containLabel: true
				// 	  },
				// 	  toolbox: {
				// 	    feature: {
				// 	      saveAsImage: {}
				// 	    }
				// 	  },
				// 	  xAxis: {
				// 	    type: 'category',
				// 	    boundaryGap: false,
				// 	    data: ['08-20', '08-19', '08-18', '08-17', '08-16', '08-15', '08-14']
				// 	  },
				// 	  yAxis: {
				// 	    type: 'value'
				// 	  },
				// 	  series: [
				// 	    {
				// 	      name: '出库数量',
				// 	      type: 'line',
				// 	      stack: 'Total',
				// 	      data: [8124, 4455, 63277, 2834, 1745, 3714, 34564]
				// 	    },
				// 		{
				// 		  name: '入库数量',
				// 		  type: 'line',
				// 		  stack: 'Total',
				// 		  data: [83874, 45144, 3467, 8124, 4317, 3347, 2464]
				// 		},
				// 	  ]
				// }),
				// myCharte.setOption({
				// 	  tooltip: {
				// 	      trigger: 'item'
				// 	    },
				// 	    legend: {
				// 	      top: '5%',
				// 	      left: 'center'
				// 	    },
				// 	    series: [
				// 	      {
				// 	        name: 'Access From',
				// 	        type: 'pie',
				// 	        radius: ['40%', '70%'],
				// 	        avoidLabelOverlap: false,
				// 	        itemStyle: {
				// 	          borderRadius: 10,
				// 	          borderColor: '#fff',
				// 	          borderWidth: 2
				// 	        },
				// 	        label: {
				// 	          show: false,
				// 	          position: 'center'
				// 	        },
				// 	        emphasis: {
				// 	          label: {
				// 	            show: true,
				// 	            fontSize: '20',
				// 	            fontWeight: 'bold'
				// 	          }
				// 	        },
				// 	        labelLine: {
				// 	          show: false
				// 	        },
				// 	        data: [
				// 	          { value: 1048, name: '规划中' },
				// 	          { value: 735, name: '工作安排' },
				// 	          { value: 580, name: '生产中' },
				// 	          { value: 484, name: '生产完成' },
				// 	        ]
				// 	      }
				// 	    ]
				// }),
				myCharpath1.setOption({
					tooltip: {
					    trigger: 'item'
					  },
					  legend: {
					    top: 'top'
					  },
					  series: [
					    {
					      name: '数量',
					      type: 'pie',
					      radius: ['30%','50%'],
					      data: [
					        { value: that.sy_ddlist.rcdd, name: '入仓单' },
					        { value: that.sy_ddlist.ccdd, name: '出仓单' },
					        { value: that.sy_ddlist.fhdd, name: '发货单' }
					      ],
					      emphasis: {
					        itemStyle: {
					          shadowBlur: 10,
					          shadowOffsetX: 0,
					          shadowColor: 'rgba(0, 0, 0, 0.5)'
					        }
					      }
					    }
					  ]
				}),
				myCharpath2.setOption({
					tooltip: {
					    trigger: 'axis',
					    axisPointer: {
					      // Use axis to trigger tooltip
					      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
					    }
					  },
					  legend: {},
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  xAxis: {
					    type: 'value'
					  },
					  yAxis: {
					    type: 'category',
					    data: [that.sy_cklist[0].name, that.sy_cklist[1].name]
					  },
					  series: [
					    {
					      name: '已存空间',
					      type: 'bar',
					      stack: 'total',
					      label: {
					        show: true
					      },
					      emphasis: {
					        focus: 'series'
					      },
					      data: [that.sy_cklist[0].num, that.sy_cklist[1].num]
					    },
					    {
					      name: '可存空间',
					      type: 'bar',
					      stack: 'total',
					      label: {
					        show: true
					      },
					      emphasis: {
					        focus: 'series'
					      },
					      data: [that.sy_cklist[0].ck_num, that.sy_cklist[1].ck_num]
					    }
					  ]
				}),
				myCharpath3.setOption({
					tooltip: {
					    trigger: 'axis',
					    axisPointer: {
					      // Use axis to trigger tooltip
					      type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
					    }
					  },
					  legend: {},
					  grid: {
					    left: '3%',
					    right: '4%',
					    bottom: '3%',
					    containLabel: true
					  },
					  xAxis: {
					    type: 'category',
						data: that.daylist
					  },
					  yAxis: {
					    type: 'value',
					  },
					  series: [
					    {
					      name: '入仓量',
					      type: 'bar',
					      stack: 'total',
					      label: {
					        show: true
					      },
					      emphasis: {
					        focus: 'series'
					      },
					      data: that.sy_cklslist_rc
					    },
					    
						{
						      name: '出仓量',
						      type: 'bar',
						      stack: 'total',
						      label: {
						        show: true
						      },
						      emphasis: {
						        focus: 'series'
						      },
						      data: that.sy_cklslist_cc
						    },
						    
					  ]
				})
			}, 1000);
		},
	},
	beforeUnmount() {
		console.log('beforeUnmount')
		if (!myChart) {
			return
		}
		// window.removeEventListener('resize', this.__resizeHandler)
		myChart.dispose()
		let myChart = null
	},
};
</script>

<style>
	.j-center{
		justify-content: center;
	}
	.a-center{
		align-items: center;
	}
	.j-j{
		flex-flow: column;
	}
	.txtx{
		font-size: 14px;font-weight: 800;color: #535353;
	}
	.gdt::-webkit-scrollbar {
		width: 0;
	}
</style>
